export class volets{
    
    volets = [];
    currentVoletKey = 0;
    
    
    set(volets){
        this.volets = volets;
        
        return this;
    }
    get(){
        return this.volets;
    }
    getCurrent(){
        return this.volets[this.currentVoletKey];
    }
    
    isActive(key){
        return key === this.currentVoletKey;
    }
    isActiveComponent(component){
        return this.getActive().component === component;
    }
    setActive(key){
        this.currentVoletKey = key
    }
    getActive(){
        return this.volets[this.currentVoletKey];
    }
    restore(data){
        console.log(data.currentVoletKey)
        this.volets = data.volets;
        this.currentVoletKey = data.currentVoletKey;
    }
    removeByType(type){
        console.log("REMOVE")
        this.volets = this.volets.filter(v => v.type !== type)
    }
}